var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBrokerInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 4.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 10V9h-1v1zm0 1v3h-1v-3z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13 6.5q0 .375-.042.742A4.502 4.502 0 0 1 11.5 16a4.5 4.5 0 0 1-4.258-3.042Q6.876 13 6.5 13A6.5 6.5 0 1 1 13 6.5m-5.975 5.475A5.49 5.49 0 0 1 2.43 10.2 7.47 7.47 0 0 1 6.5 9q.612 0 1.196.095a4.48 4.48 0 0 0-.671 2.88M8.42 8.218A8.5 8.5 0 0 0 6.5 8a8.46 8.46 0 0 0-4.674 1.4 5.5 5.5 0 1 1 10.15-2.375 4.48 4.48 0 0 0-3.554 1.193M15 11.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
  clipRule: "evenodd"
})));
export default SvgBrokerInfoIcon;